var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStorage = function SvgStorage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#storage_svg__a)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 61.188,
    height: 41.188,
    x: -2.594,
    y: -5.945
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#storage_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#storage_svg__c)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#storage_svg__d)",
    d: "M8 8.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C11.04 2 12.16 2 14.4 2h27.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C48 5.04 48 6.16 48 8.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C44.96 22 43.84 22 41.6 22H14.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C8 18.96 8 17.84 8 15.6z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    d: "M14.4 2.5h27.2c1.128 0 1.945 0 2.587.053.636.052 1.056.153 1.402.329a3.5 3.5 0 0 1 1.53 1.53c.175.345.276.765.328 1.401.053.642.053 1.459.053 2.587v7.2c0 1.128 0 1.945-.053 2.586-.052.637-.153 1.057-.329 1.403a3.5 3.5 0 0 1-1.53 1.53c-.345.175-.765.276-1.401.328-.642.053-1.459.053-2.587.053H14.4c-1.128 0-1.945 0-2.587-.053-.636-.052-1.056-.153-1.402-.329a3.5 3.5 0 0 1-1.53-1.53c-.175-.345-.276-.765-.328-1.402C8.5 17.545 8.5 16.729 8.5 15.6V8.4c0-1.128 0-1.945.053-2.587.052-.636.153-1.056.329-1.402a3.5 3.5 0 0 1 1.53-1.53c.345-.175.765-.276 1.401-.328.322-.026.686-.04 1.112-.046z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 61.188,
    height: 41.188,
    x: -2.594,
    y: 10.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#storage_svg__e)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#storage_svg__f)",
    shapeRendering: "crispEdges"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#storage_svg__g)",
    fillOpacity: 0.5,
    d: "M8 24.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C11.04 18 12.16 18 14.4 18h27.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C48 21.04 48 22.16 48 24.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C44.96 38 43.84 38 41.6 38H14.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C8 34.96 8 33.84 8 31.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#storage_svg__h)",
    fillOpacity: 0.25,
    d: "M8 24.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C11.04 18 12.16 18 14.4 18h27.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C48 21.04 48 22.16 48 24.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C44.96 38 43.84 38 41.6 38H14.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C8 34.96 8 33.84 8 31.6z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.1,
    d: "M14.4 18.5h27.2c1.128 0 1.945 0 2.587.053.636.052 1.056.153 1.402.329a3.5 3.5 0 0 1 1.53 1.53c.175.345.276.765.328 1.402.053.641.053 1.458.053 2.586v7.2c0 1.128 0 1.945-.053 2.587-.052.636-.153 1.056-.329 1.402a3.5 3.5 0 0 1-1.53 1.53c-.345.175-.765.276-1.401.328-.642.053-1.459.053-2.587.053H14.4c-1.128 0-1.945 0-2.587-.053-.636-.052-1.056-.153-1.402-.329a3.5 3.5 0 0 1-1.53-1.53c-.175-.345-.276-.765-.328-1.401C8.5 33.545 8.5 32.728 8.5 31.6v-7.2c0-1.128 0-1.945.053-2.586.052-.637.153-1.057.329-1.403a3.5 3.5 0 0 1 1.53-1.53c.345-.175.765-.276 1.401-.328.322-.027.686-.04 1.112-.046z"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 61.188,
    height: 41.188,
    x: -2.594,
    y: 26.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#storage_svg__i)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#storage_svg__j)",
    shapeRendering: "crispEdges"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#storage_svg__k)",
    fillOpacity: 0.2,
    d: "M8 40.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C11.04 34 12.16 34 14.4 34h27.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C48 37.04 48 38.16 48 40.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C44.96 54 43.84 54 41.6 54H14.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C8 50.96 8 49.84 8 47.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#storage_svg__l)",
    d: "M8 40.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C11.04 34 12.16 34 14.4 34h27.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C48 37.04 48 38.16 48 40.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C44.96 54 43.84 54 41.6 54H14.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C8 50.96 8 49.84 8 47.6z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M14.4 34.5h27.2c1.128 0 1.945 0 2.587.053.636.052 1.056.153 1.402.329a3.5 3.5 0 0 1 1.53 1.53c.175.345.276.765.328 1.401.053.642.053 1.459.053 2.587v7.2c0 1.128 0 1.945-.053 2.587-.052.636-.153 1.056-.329 1.402a3.5 3.5 0 0 1-1.53 1.53c-.345.175-.765.276-1.401.328-.642.053-1.459.053-2.587.053H14.4c-1.128 0-1.945 0-2.587-.053-.636-.052-1.056-.153-1.402-.329a3.5 3.5 0 0 1-1.53-1.53c-.175-.345-.276-.765-.328-1.401C8.5 49.545 8.5 48.728 8.5 47.6v-7.2c0-1.128 0-1.945.053-2.587.052-.636.153-1.056.329-1.402a3.5 3.5 0 0 1 1.53-1.53c.345-.175.765-.276 1.401-.328.322-.026.686-.04 1.112-.046z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#storage_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 11h14"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#storage_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 27h14"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#storage_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 43h14"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "storage_svg__c",
    width: 61.188,
    height: 41.188,
    x: -2.594,
    y: -5.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_3616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_3616",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "storage_svg__f",
    width: 61.188,
    height: 41.188,
    x: -2.594,
    y: 10.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_3616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_3616",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "storage_svg__j",
    width: 61.188,
    height: 41.188,
    x: -2.594,
    y: 26.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_3616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_3616",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "storage_svg__m",
    width: 18,
    height: 4,
    x: 19,
    y: 10,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4772_3616"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4772_3616",
    result: "effect2_dropShadow_4772_3616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4772_3616",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "storage_svg__n",
    width: 18,
    height: 4,
    x: 19,
    y: 26,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4772_3616"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4772_3616",
    result: "effect2_dropShadow_4772_3616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4772_3616",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "storage_svg__o",
    width: 18,
    height: 4,
    x: 19,
    y: 42,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4772_3616"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4772_3616",
    result: "effect2_dropShadow_4772_3616"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4772_3616",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "storage_svg__b",
    transform: "translate(2.594 5.945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C11.04 2 12.16 2 14.4 2h27.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C48 5.04 48 6.16 48 8.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C44.96 22 43.84 22 41.6 22H14.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C8 18.96 8 17.84 8 15.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "storage_svg__e",
    transform: "translate(2.594 -10.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 24.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C11.04 18 12.16 18 14.4 18h27.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C48 21.04 48 22.16 48 24.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C44.96 38 43.84 38 41.6 38H14.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C8 34.96 8 33.84 8 31.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "storage_svg__i",
    transform: "translate(2.594 -26.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 40.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C11.04 34 12.16 34 14.4 34h27.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C48 37.04 48 38.16 48 40.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C44.96 54 43.84 54 41.6 54H14.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C8 50.96 8 49.84 8 47.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "storage_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "storage_svg__d",
    x1: 29.25,
    x2: 29.25,
    y1: 2.294,
    y2: 35.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "storage_svg__g",
    x1: 28,
    x2: 28,
    y1: 26.875,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "storage_svg__k",
    x1: 28,
    x2: 28,
    y1: 42.875,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "storage_svg__h",
    width: 1.6,
    height: 3.2,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#storage_svg__p",
    transform: "scale(.00156 .00313)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "storage_svg__l",
    width: 1.6,
    height: 3.2,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#storage_svg__p",
    transform: "scale(.00156 .00313)"
  })))));
};
export default SvgStorage;